import { createStore, applyMiddleware, compose } from 'redux';
import middleware from '../middleware';
import reducers from '../reducers';

const devToolsExtension = window.devToolsExtension ?
  window.devToolsExtension() :
  f => f;

const store = createStore(
  reducers,
  compose(applyMiddleware(...middleware), devToolsExtension)
);

export default store;
